export enum syncUiType {
  SET_SYNC_ENDING_LIVE = 'SET_SYNC_SYNC_ENDING_LIVE',
  SET_SYNC_FOCUS_ON = 'SET_SYNC_FOCUS_ON',
  SET_SYNC_SCREENSHARE_FOCUS = 'SET_SYNC_SCREENSHARE_FOCUS',
  SET_SYNC_DOMINANT_SPEAKER = 'SET_SYNC_DOMINANT_SPEAKER',
  SET_SYNC_GIG_TERMINATION_TIME = 'SET_SYNC_GIG_TERMINATION_TIME',
  SET_SYNC_GOING_LIVE = 'SET_SYNC_GOING_LIVE',
  SET_SYNC_LIVE_DATE_TIME = 'SET_SYNC_LIVE_DATE_TIME',
  SET_SYNC_LIVE_ENDED = 'SET_SYNC_LIVE_ENDED',
  SET_SYNC_MEDIA_TYPE = 'SET_SYNC_MEDIA_TYPE',
  SET_SYNC_MUTE = 'SET_SYNC_MUTE',
  SET_SYNC_PLAYIN_MUTE = 'SET_SYNC_PLAYIN_MUTE',
  SET_SYNC_PARTICIPANT_INFORMATION = 'SET_SYNC_PARTICIPANT_INFORMATION',
  SET_SYNC_PRESENTER_COUNT = 'SET_SYNC_PRESENTER_COUNT',
  SET_SYNC_VIDEO_DISPLAY = 'SET_SYNC_VIDEO_DISPLAY',
  SET_SYNC_SLIDE_POSITION = 'SET_SYNC_SLIDE_POSITION',
  SET_SYNC_PENDING_SLIDES_ID = 'SET_SYNC_PENDING_SLIDES_ID',
  SET_UI_INITIAL_STATE_ERROR = 'SET_UI_INITIAL_STATE_ERROR',
  SET_SYNC_AUTO_SPOTLIGHT = 'SET_SYNC_AUTO_SPOTLIGHT',
  SET_SYNC_EVENT_STREAM_URL = 'SET_SYNC_EVENT_STREAM_URL',
  SET_SYNC_LAYOUTS = 'SET_SYNC_LAYOUTS',
  NO_SYNC_UI_UPDATES_TO_APPLY = 'NO_SYNC_UI_UPDATES_TO_APPLY',
  SET_SYNC_CHECK_DIAL_IN_NOTIFICATION = 'SET_SYNC_CHECK_DIAL_IN_NOTIFICATION',
  SET_SYNC_CONVERSATION_CREATOR_ID = 'SET_SYNC_CONVERSATION_CREATOR_ID',
  SET_SYNC_CONVERSATION_NAME = 'SET_SYNC_CONVERSATION_NAME',
  SET_SYNC_QUESTIONS = 'SET_SYNC_QUESTIONS'
}
